<script>
    // -- IMPORTS

    import { getLocalizedText } from "senselogic-gist";
    import AdminEditButton from "../element/AdminEditButton.svelte";
    import AnimatedContainer from "../element/AnimatedContainer.svelte";
    import Media from "../element/Media.svelte";
    import { enabledAdminView } from "$src/lib/store/adminStore";
    import { languageTagStore } from "$src/lib/store/languageTagStore";
    import { getProcessedMultilineTranslatedText } from "$src/lib/base";
    import Button from "../element/Button.svelte";

    // -- VARIABLES

    /** @type {{block?: any}} */
    let { block = $bindable({}) } = $props();
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    // -- CLASSES

    .text-and-image-container
    {
        position: relative;

        width: 100%;

        display: flex;
        flex-direction: column;
        gap: 2.5rem;
        align-items: flex-start;
        align-self: stretch;

        +media( desktop )
        {
            max-width: 77vw;

            flex-direction: row;
            gap: 2.5rem;
        }
    }

    .text-and-image-container.reverse
    {
        +media( desktop )
        {
            flex-direction: row-reverse;
        }
    }

    .text-and-image-content
    {
        width: 100%;
        
        display: flex;
        flex-direction: column;
        gap: 1rem;
        align-items: flex-start;
        align-self: stretch;

        +media( desktop )
        {
            max-width: 50%;

            display: flex;
            flex: 1 0 0;
            gap: 2rem;
            justify-content: center;
        }
    }

    .text-and-image-title
    {
        line-height: 2rem;
        font-size: 1.4375rem;
        font-weight: 500;
        letter-spacing: 0.08625rem;
        text-transform: uppercase;

        +media( desktop )
        {
            line-height: 2.5rem;
            font-size: 2rem;
            letter-spacing: 0.16rem;
        }
    }

    .image-block-container
    {    
        height: 18.75rem;
        width: 100%;
        aspect-ratio: 1;

        align-self: stretch;

        +media( desktop )
        {
            position: sticky;
            top: 8rem;

            height: 40rem;
            width: 44.375rem;
            aspect-ratio: 3 / 4;
        }
    }

    :global( .image-block )
    {
        aspect-ratio: 1;

        align-self: stretch;
        object-fit: cover;

        +media( desktop )
        {
            height: 40rem;
            width: 44.375rem;
            aspect-ratio: 3 / 4;
        }
    }

    .description-text
    {
        display: -webkit-box;
        -webkit-box-orient: vertical;

        max-height: 35rem;
        padding-bottom: 5rem;

        line-height: 2rem;
        font-size: 1.125rem;

        transition: max-height 2.6s cubic-bezier(0, 1, 0, 1);

        +media( desktop )
        {
            line-height: 2.25rem;
            font-size: 1.25rem;
            letter-spacing: 0.03rem;
            color: lightGrayColor;
        }
    }

    .description-and-cta
    {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 4rem;
    }

    .block-item-text-overlay
    {
        position: absolute;
        bottom: 0;
        left: 0;

        height: 10%;
        width: 100%;

        background: linear-gradient( 180deg, rgba(27, 27, 27, 0.00) 0%, #1B1B1B 100% );

        pointer-events: none;
        transition: height 1.2s;
    }
</style>

<div>
    {#key block}
        <AnimatedContainer style="width: 100%; display: flex; align-items: center; justify-content: center;">
            <div 
                id={ block.slug || 'id' }
                class="text-and-image-container { block.typeSlug === 'text-and-media' ? 'reverse' : '' }" 
                class:is-admin-enabled={ $enabledAdminView }>
    
                {#if block.mediaPath || block.mediaPathArray}
                    <div class="image-block-container">
                        <Media
                            mediaPath={ block.mediaPathArray?.length > 0 ? block.mediaPathArray : block.mediaPath }
                            mediaClass="image-block"
                            mediaId={ block.id }
                            mediaPosition={{
                                vertical: block.imageVerticalPosition || 'center',
                                horizontal: block.imageHorizontalPosition || 'center',
                                horizontalArray: block.imageHorizontalPositionArray || [ 'center' ],
                                verticalArray: block.imageVerticalPositionArray || [ 'center' ],
                            }}
                        />
                    </div>
                {/if}
    
                <div class="text-and-image-content">
                    {#if block.title}
                        <p class="text-and-image-title color-light-gold">{@html getProcessedMultilineTranslatedText( block.title || '', $languageTagStore )}</p>
                    {/if}
    
                    <div class="description-and-cta">
                        {#if block.text}
                            <p 
                                class="block-text"
                                id={`block-${ block.id }`}
                            >
                                {@html getProcessedMultilineTranslatedText( block.text, $languageTagStore )}
                            </p>
                        {/if}
        
        
                        {#if block.teaser && block.href}
                            <Button href={ block.href } style="letter-spacing: 1.5px;" target="_blank">
                                { getLocalizedText( block.teaser, $languageTagStore ) }
                            </Button>
                        {/if}
                    </div>
                </div>
            </div>
        </AnimatedContainer>
    {/key}
</div>